export default __webpack_public_path__ + "static/media/memberCard.f553236a.svg";